export default __webpack_public_path__ + "static/media/how_to_play_icon_1.6b1c9227.png";